import { fastConcatMP4 } from "@webav/av-cliper";

import { fileToStream, streamToFile } from "./stream-utils";

export const concatenateMP4 = async (mp4s: File[]) => {
  const streams = await Promise.all(mp4s.map((item) => fileToStream(item)));
  const concatenated = await fastConcatMP4(streams);
  return streamToFile(concatenated, "output.mp4", "video/mp4");
};
